import type { SalesQueryContext } from '@/api/sass/rate-query/types'
export type { SalesQueryContext } from '@/api/sass/rate-query/types'

/** 从列表携带的路由恢复选择，客户 ID 保持字符串，等级零有效。 */
export const salesQueryContextFromRoute = (query: Record<string, unknown>): SalesQueryContext => {
  if (typeof query.clientId === 'string' && query.clientId) return { clientId: query.clientId }
  const value = typeof query.clientLevel === 'string' && query.clientLevel !== '' ? Number(query.clientLevel) : NaN
  return Number.isInteger(value) && value >= 0 ? { clientLevel: value } : {}
}

/** 详情页沿用列表所选客户，不把长整数 ID 转成 number。 */
export const salesQueryRoute = (context: SalesQueryContext): Record<string, string> => context.clientId
  ? { clientId: context.clientId }
  : context.clientLevel !== undefined ? { clientLevel: String(context.clientLevel) } : {}
